<div>
  @if (canViewClient) {
    <a
      target="_blank"
      routerLink="/capture-admin/client-management/clients/{{ client.id }}"
      >
      {{ client.name }}
    </a>
  }
  @if (!canViewClient) {
    <span>{{ client.name }}</span>
  }
  <app-copy-to-clipboard [text]="client.name" />
  ({{ client.state }})
</div>